// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__t9Iq-","Open":"SideDrawer_Open__WVzQ5","Close":"SideDrawer_Close__T-tXY"};